import { atom } from "recoil";


const MotherState = atom({
    key: 'currentMother',
    default: {},
});
  
export default MotherState